import RecommendTab from "../components/RecommendPage/RecommendTab.js"


export default function Main() {
  return (
    <>
      <div style={{ height: "700px", background: `url(${require("../assets/images/recbg.png").default}) no-repeat center` }}></div>
      <RecommendTab />
    </>
  );
}